import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { Device } from 'src/app/models/Device';
import { Cacheable } from 'ts-cacheable';
import { BaseService } from '../base.service';

@Injectable({ providedIn: 'root' })
export class DeviceService extends BaseService {
  constructor(protected http: HttpClient) {
    super(http);
  }

  @Cacheable({
    maxAge: 1000 * 60 * 60 * 24,
  })
  getAll(): Observable<Device[]> {
    return this.callGet('/devices').pipe(
      map((response: any) => {
        if (response && Array(response.data)) {
          return response.data.map(Device.parseFromData);
        }
        return [];
      }),
      catchError((response: HttpErrorResponse) =>
        this.getResponseMessage(response, 'Unable to load devices')
      )
    );
  }

  subscribe(data: any): Observable<any> {
    return this.callPost(`/devices`, data).pipe(
      map((response: any) => true),
      catchError((response: HttpErrorResponse) =>
        this.getResponseMessage(response, 'Unable to subscribe')
      )
    );
  }

  modifySubscription(data: any): Observable<any> {
    return this.callPost(`/devices`, data).pipe(
      map((response: any) => true),
      catchError((response: HttpErrorResponse) =>
        this.getResponseMessage(response, 'Unable to change subscription')
      )
    );
  }
}
